module.exports = __webpack_public_path__ + "img/not_found (2).b709ab46.jpg";